const ACTIVATE_BLOG_LISTING = "ACTIVATE_BLOG_LISTING";
const ACTIVATE_PLANNER_LISTING = "ACTIVATE_PLANNER_LISTING";
const ACTIVATE_PROFILE_LISTING = "ACTIVATE_PROFILE_LISTING";

export default {
  ACTIVATE_BLOG_LISTING,
  ACTIVATE_PLANNER_LISTING,
  ACTIVATE_PROFILE_LISTING
};
